import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reporte-excedentes-page',
  templateUrl: './reporte-excedentes-page.component.html',
  styleUrls: ['./reporte-excedentes-page.component.css']
})
export class ReporteExcedentesPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
